// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: '82a5ad7',
    builtAt: '2026-09-16T16:05:18.905Z',
} as const;
